import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { getQueryStringVariable } from './data/utils/getQueryStringVariable';
import { loadIdPvr } from './data/utils/loadIdPvr';
import { loadLanguage } from './data/utils/loadLanguage';
import { loadSessionToken } from './data/utils/loadSessionToken';
import { loadSystemCode } from './data/utils/loadSystemCode';
import { appConfig } from './appConfig';

export const warName = process.env.REACT_APP_WAR_NAME? process.env.REACT_APP_WAR_NAME : 'XSportDatastore';
export const apiDomain = process.env.REACT_APP_API_DOMAIN;
export const systemCode =  loadSystemCode(apiDomain) || ( (appConfig['SYSTEM_CODE']||null) != null ? appConfig['SYSTEM_CODE'] : '');
export const xs_sessionToken = loadSessionToken();
export const xs_instantSessionToken = getQueryStringVariable("tokenInstant");
export const xs_languageCode = loadLanguage();
export const xs_idPvr = loadIdPvr();
export const xs_isMobile = true;
export const xs_product_code = 1;


/*(function loadScriptsFromDataConfig() {
  const scriptUrls = [];
  const cssHrefs = []
  const configuration = getConfiguration();
  try {
      configuration['ps']['lte']['BETRADAR_WIDGET'] && scriptUrls.push(configuration['ps']['lte']['BETRADAR_WIDGET']['ujs']['ALL']);
        const streamingRadar = getBetradarStreamingProps();
        if(streamingRadar){
        	scriptUrls.push(apiDomain + '/XSportDatastore/content/js/streaming/avvpl-player.js')
          cssHrefs.push(apiDomain + '/XSportDatastore/content/js/streaming/style/styles.css')
        }

  }catch(err){
    console.log(err);
  }

  try {
    const s5_URL = configuration['ps']['lte']['BETRADAR_WIDGET_S5'] &&  configuration['ps']['lte']['BETRADAR_WIDGET_S5']['ujs']['ALL'];
    if(s5_URL){
        initBetradarWidgetS5(s5_URL,xs_languageCode);
    }
  }catch(err){
        console.log(err)
  }

  cssHrefs.forEach(function(h){
    var css = document.createElement('link');
    css.setAttribute("rel","stylesheet")
    css.setAttribute('href',h);
    document.head.appendChild(css);
});

  scriptUrls.forEach(function(s){
      var script = document.createElement('script');
      script.setAttribute('src',s);
      document.head.appendChild(script);
  });

}());*/

if(typeof String.prototype.replaceAll == 'undefined'){
  console.log("replaceAll is not defined! I create it!");
  String.prototype.replaceAll = function(target, replacement) {
        return this.split(target).join(replacement);
  };
}

window.whenJqueryLoaded(function () {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('xsport-container')
  );
});

if(window.appConfig){
  const afDOMRendered = window.appConfig.HANDLERS &&  window.appConfig.HANDLERS['afterDOMRendered'];
  if(typeof afDOMRendered==='function')
    afDOMRendered();
}
